import { CerFormAdapter } from '@cer/cer-form/cer-form-adapter';
import { CerFormView } from '@cer/cer-form/cer-form-view';
import { FieldWidthEnum } from 'src/cer/cer-data/cer-data-types';
import { UiCommand } from '@ui/cer-ui-types';

const onlySalesCmd: UiCommand = {
  id: 'onlySalesCmd', text: 'Vis alle', align: 'right',
  iconCss: "e-menu-icon e-icons e-circle-check", tooltipText: 'Vis kun salg', target: ".e-content", visible: true
};

export class WarehouseOutboundReserveTransForm extends CerFormAdapter {

  override view(): CerFormView {
    return new CerFormView({
      viewMetadata: {
        name: 'lager-reservationer', dataApiName: 'WarehouseOutboundOrderReserve', text: 'Lagerreservationer', textSingular: 'Lagerreservation',
        primaryKey: 'pickOrderNum', allowEdit: false, allowCreate: false, allowDelete: false
      },
      toolbarCommands: [onlySalesCmd],
      fieldMetadata: [
        { name: 'orderLockedDate', text: 'Låst dato', format: 'DateShort', orderByPriority: 1, orderBy: 'Descending' },
        { name: 'outboundOrderNum', text: 'Forsendelse', foreignKeyType: 'warehouseOutboundOrderLookup', orderByPriority: 2, orderBy: 'Descending' },
        { name: 'pickOrderNum', text: 'Lager ordre', visible: false },
        { name: 'warehouseCounterpart', text: 'Kundenr.', widthType: FieldWidthEnum.XS, visible: false },
        { name: 'customerRef', text: 'Kunderef.', widthType: FieldWidthEnum.XS, visible: false },
        { name: 'purchOrderNum', text: 'Reference', widthType: FieldWidthEnum.XS },
        { name: 'created', text: 'Oprettet', tooltipText: 'Oprettet dato', allowEdit: false, format: 'DateLong' },
        { name: 'modified', text: 'Ændret', tooltipText: 'Ændret dato', allowEdit: false, format: 'DateLong', visible: false },
        { name: 'createdJobId', text: 'Oprettet job', format: 'Number', visible: false },
        { name: 'modifiedJobId', text: 'Ændret job', format: 'Number', visible: false }
      ]
    });
  }
}
